import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
} from '@angular/core';
import { getNameAbbreviation, getAvatarColor } from '../../utils/name.utils';

@Component({
    selector: 'app-user-profile-img',
    templateUrl: './user-profile-img.component.html',
    styleUrls: ['./user-profile-img.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule],
})
export class UserProfileImgComponent {
    @Input() public firstName: string | undefined = undefined;
    @Input() public lastName: string | undefined = undefined;
    @Input() public userId: string | undefined = undefined;
    @Input() public imgSrc: string | undefined = undefined;
    @Input() public size: string = '56px';
    @Input() public fontSize: string = '18px';
    @Input() public title: string | undefined = undefined;

    @Input() public colorPalete: 'primary' | 'light' | 'hash' = 'hash';

    public initials: string = '(ツ)';

    public get getInitials(): string {
        return getNameAbbreviation(this.firstName, this.lastName);
    }

    public get getBackgroundColor(): string {
        if (this.imgSrc) {
            return 'transparent';
        }

        if (this.colorPalete === 'hash') {
            // Use hash-based color from userId, or fallback to name if userId not provided
            const identifier = `${this.firstName || ''}${this.lastName || ''}`.trim();
            return getAvatarColor(identifier);
        } else if (this.colorPalete === 'primary') {
            return '#0653AB';
        } else {
            return '#DDDDDD';
        }
    }

    public get getTextColor(): string {
        if (this.imgSrc) {
            return '';
        }

        if (this.colorPalete === 'hash') {
            // White text for hash-based colors (they're all dark enough)
            return '#FFFFFF';
        } else if (this.colorPalete === 'primary') {
            return '#FDFDFD';
        } else {
            return '#0653AB';
        }
    }
}
